<template>
	<div class="modify-variable-container">
		<div class="header">
			<button class="qd-button qd-btn-white mx-1" @click="save()">ذخیره و بازگشت</button>
			<button class="qd-button qd-btn-outline-white" @click="close()">بازگشت</button>
		</div>
		<div class="body">
			<div class="variable-row nk-card">
				<div class="qd-col-form-group">
					<span class="qd-col-form-title">نام:</span>
					<input class="qd-col-form-data qd-input" v-model="localData.name" style="width:180px;" />
				</div>
			</div>
			<div class="variable-row">
				<!-- <label>نوع:</label>
        <label
          ><input
            type="radio"
            v-model="type"
            name="type"
            value="staticValue"
          />مقدار ثابت</label
        >
        <label
          ><input
            type="radio"
            v-model="type"
            name="type"
            value="dynamicValue"
          />مقدار داینامیک</label
        > -->
			</div>
			<div>
				<div class="variable-row" v-if="type === 'staticValue'">
					<label>مقدار:</label>
					<input type="text" v-model="localData.staticValue" />
				</div>
				<div v-if="type === 'dynamicValue'" style="padding-top: 10px">
					<QueryVisualizer v-model="localData.dynamicValue" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		name: 'ModifyVariable',
		props: {
			value: {
				type: Object,
			},
		},
		emits: ['resolved'],
		data() {
			return {
				localData: {
					name: '',
					staticValue: null,
					dynamicValue: null,
				},
				type: '',
				queryDesignerData: null,
			}
		},
		mounted() {
			this.localData = { ...this.value }
			this.type = this.localData.staticValue
				? 'staticValue'
				: this.localData.dynamicValue
					? 'dynamicValue'
					: 'dynamicValue'
		},
		methods: {
			save() {
				if (this.localData.name.length === 0) {
					alert('نام متغیر را وارد کنید')
					return
				}
				if (this.type === 'staticValue' && (!this.localData.staticValue || this.localData.staticValue.length === 0)) {
					alert('مقدار را وارد کنید')
					return
				}
				this.$emit('resolved', this.localData)
			},
			close() {
				this.$emit('resolved')
			},
		},
	}
</script>

<style></style>